import { render } from "./BookingsList.vue?vue&type=template&id=7f4ec972"
import script from "./BookingsList.vue?vue&type=script&lang=js"
export * from "./BookingsList.vue?vue&type=script&lang=js"
script.render = render

export default script